import { useCallback, useMemo } from 'react';
import { adminApi } from '../../services/adminApi';
import AdminGrid from './AdminGrid';

const fmtDate = (p) => p.value ? new Date(p.value).toLocaleDateString() : '-';

export default function OrgCompaniesTab({ orgId }) {
  const columns = useMemo(() => [
    { field: 'companyName', headerName: 'Company', minWidth: 180 },
    { field: 'realmId', headerName: 'Realm ID' },
    { field: 'country', headerName: 'Country' },
    { field: 'currency', headerName: 'Currency' },
    { field: 'connected', headerName: 'Connected', valueGetter: (p) => p.data?.connected ? 'Yes' : 'No' },
    { field: 'reportsCount', headerName: 'Reports', filter: 'agNumberColumnFilter' },
    { field: 'lastSync', headerName: 'Last Sync', valueFormatter: fmtDate },
  ], []);

  const fetchData = useCallback(async () => {
    const res = await adminApi.getOrgCompanies(orgId, 0, 10000);
    return res.content || [];
  }, [orgId]);

  return <AdminGrid columns={columns} fetchData={fetchData} />;
}
